import { Avatar, Box, Button, Divider, Typography } from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import SuccessModal from "../../../utils/SuccessModal";

const CommentSection = ({ tender, storedUser }) => {
  const [user, setUser] = useState();
  const [comments, setComments] = useState([]);
  const [reason, setReason] = useState("");
  const [open, setOpen] = useState(false);
  const [msg, setMsg] = useState();
  const handleClose = () => setOpen(false);

  useEffect(() => {
    const getUser = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/org-user?username=${storedUser.username}`,
          {
            headers: { Authorization: `Bearer ${storedUser.accessToken}` },
          }
        );
        setUser(res.data);
      } catch (error) {
        console.log(error);
      }
    };
    getUser();
  }, []);

  const getComments = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/comment?tenderId=${tender.tenderId}`,
        {
          headers: { Authorization: `Bearer ${storedUser.accessToken}` },
        }
      );
      setComments(res.data);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    getComments();
  }, [tender]);

  const handleComment = async () => {
    try {
      await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/comment`,
        {
          username: storedUser.username,
          tenderId: tender.tenderId,
          reason: reason,
        },
        {
          headers: { Authorization: `Bearer ${storedUser.accessToken}` },
        }
      );
      setReason("");
      setOpen(true);
      setMsg("Comment Added!")
      getComments();
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <div className="dashboard-container">
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography variant="h5">Comments</Typography>
        <input
          type="text"
          placeholder="Search"
          style={{ margin: 0, width: "300px" }}
        />
      </div>
      <Box className="dashboard-container" sx={{ px: 8 }}>
        <Box
          className="dashboard-container"
          sx={{
            background: "#F6F6F6",
            boxShadow: "0px 3px 12.3px 0px #CCE0FF",
          }}
        >
          <Box
            sx={{
              display: "inline-flex",
              alignItems: "center",
              gap: 2,
              color: "#00247E",
              fontWeight: "600",
            }}
          >
            <Avatar {...stringAvatar(`${user && user.name}`)} />
            {user && user.name}
          </Box>
          <textarea
            name="reason"
            id="reason"
            rows={2}
            style={{
              border: "none",
              margin: "10px 0 0 0",
              background: "#F6F6F6",
            }}
            value={reason}
            onChange={(e) => setReason(e.target.value)}
          ></textarea>
          <Divider />
          <div style={{ display: "flex", justifyContent: "end" }}>
            <Button className="btn-contained" onClick={handleComment}>
              Add Comment
            </Button>
          </div>
        </Box>

        <div>
          {comments ? (
            comments.map((comment, index) => (
              <React.Fragment key={index}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 15,
                  }}
                >
                  <Avatar {...stringAvatar(`${comment.orgUser && comment.orgUser.name}`)} />
                  <div>
                    <Typography sx={{ color: "#00247E", fontWeight: "600" }}>
                      {comment.orgUser.name}
                    </Typography>
                    <Typography fontSize="14px" variant="span" color="#272525">
                      {comment.type === "Manual" ? (
                        "Manual Comment"
                      ) : comment.type === "Vendor" ? (
                        comment.status === "DISQUALIFIED" ? (
                          <>
                            Vendor <a href={`/dashboard/${tender.tenderId}/vendor/${comment.vtqId}`}>{comment.vendor.name}</a> Rejected By {capitalize(comment.orgUser.userRoleName)} {comment.orgUser.name}
                          </>
                        ) : (
                          <>
                            Vendor <a href={`/dashboard/${tender.tenderId}/vendor/${comment.vtqId}`}>{comment.vendor.name}</a> Approved By {capitalize(comment.orgUser.userRoleName)} {comment.orgUser.name}
                          </>
                        )
                      ) : comment.type === "Bid" ? (
                        comment.status === "REJECTED" ? (
                          <>
                            Bid of vendor <a href={`/dashboard/${tender.tenderId}/vendor/${comment.vtqId}`}>{comment.vendor.name}</a> Rejected By {capitalize(comment.orgUser.userRoleName)} {comment.orgUser.name}
                          </>
                        ) : (
                          <>
                            Bid of vendor <a href={`/dashboard/${tender.tenderId}/vendor/${comment.vtqId}`}>{comment.vendor.name}</a> Approved By {capitalize(comment.orgUser.userRoleName)} {comment.orgUser.name}
                          </>
                        )
                      ) : comment.status === "REJECTED" ? (
                        `Tender Rejected By ${capitalize(
                          comment.orgUser.userRoleName
                        )} ${comment.orgUser.name}`
                      ) : comment.status === "REWORK" ? (
                        `Tender Sent For Rework By ${capitalize(
                          comment.orgUser.userRoleName
                        )} ${comment.orgUser.name}`
                      ) : (
                        `Tender Approved By ${capitalize(
                          comment.orgUser.userRoleName
                        )} ${comment.orgUser.name}`
                      )}
                    </Typography>
                  </div>
                </div>
                <Box px={7}>
                  <div
                    className="dashboard-container"
                    style={{
                      background: "#F6F6F6",
                      borderRadius: "0",
                      padding: "5px 20px",
                    }}
                  >
                    <p style={{ color: "#272525" }}>"{comment.comment}"</p>
                  </div>
                  <div style={{ display: "flex", justifyContent: "end" }}>
                    <span style={{ fontSize: "12px", marginTop: "-15px" }}>
                      {new Date(comment.updatedDate)
                        .toLocaleString("en-IN", {
                          day: "2-digit",
                          month: "2-digit",
                          year: "numeric",
                          hour: "2-digit",
                          minute: "2-digit",
                          hour12: true,
                        })
                        .replace(",", " |")}
                    </span>
                  </div>
                </Box>
              </React.Fragment>
            ))
          ) : (
            <Box textAlign={"center"}>No Comments</Box>
          )}
        </div>
      </Box>

      <SuccessModal open={open} handleClose={handleClose} msg={msg}/>
    </div>
  );
};

export default CommentSection;

function stringAvatar(name) {
  const parts = name.trim().split(" ");
  if (parts.length === 1) {
    return {
      children: parts[0][0].toUpperCase(),
    };
  } else {
    return {
      children: `${parts[0][0]}${parts[1][0]}`.toUpperCase(),
    };
  }
}

const capitalize = (str) =>
  str
    .replace(/_/g, " ")
    .toLowerCase()
    .replace(/\b\w/g, (char) => char.toUpperCase());